import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Common } from 'ws-scripts/modules/common';
import QuickSpecs from '../components/QuickSpecs';

class WidgetContainer extends Component {
	render() {
		if (!this.props.quickSpecs) {
			return null;
		}

		return (
			<Common
				render={({ labels }) => {
					return (
						<QuickSpecs
							quickSpecs={this.props.quickSpecs}
							deviceType={this.props.deviceType}
							vehicleType={this.props.vehicleType}
							labels={labels}
						/>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	deviceType: PropTypes.string.isRequired,
	quickSpecs: PropTypes.shape({}).isRequired,
	vehicleType: PropTypes.string.isRequired
};

const mapStateToProps = state => {
	return {
		quickSpecs: state.quickSpecs,
		vehicleType: state.vehicleType,
		deviceType: state.requestData.deviceType
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;
